export class GetTableContextFileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "file",
            "baseName": "file",
            "type": "TableContextFile",
            "format": ""
        },
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        },
        {
            "name": "versionId",
            "baseName": "versionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableContextFileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
